type CheckboxColor =
  | "custom"
  | "green"
  | "orange"
  | "sky"
  | "yellow"
  | "red"
  | "purple"
  | "light"
  | "dark";

type CustomCheckboxProps = {
  id: string;
  label: string;
  color: CheckboxColor;
  //defaultChecked?: boolean;
  disabled?: boolean;
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const CheckBoxComponent: React.FC<CustomCheckboxProps> = ({
  label,
  color,
  //defaultChecked = false,
  disabled = false,
  id,
  value,
  onChange,
}) => {
  return (
    <div className="flex items-center gap-2">
      <input
        id={id}
        className={`size-4 border rounded-sm appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zinc-600 dark:border-zinc-500 
      checked:bg-${color}-500 checked:border-${color}-500 dark:checked:bg-${color}-500 dark:checked:border-${color}-500 
      checked:disabled:bg-${color}-400 checked:disabled:border-${color}-400`}
        type="checkbox"
        //defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        checked={value}
      />
      <label htmlFor={id} className="align-middle">
        {label}
      </label>
    </div>
  );
};
